import { useEffect, useState, useContext } from 'react';
import { useForm } from "react-hook-form";
import { Modal, Button } from 'react-bootstrap';
import * as Api from '../../../api/Api';
import { useQuery } from 'react-query';
import * as KeyNames from '../../../api/KeyNames';
import { ErrorConnection } from '../../../Components/Error/Error';
import { Loading } from '../../../Components/Loading/Loading';
import { FeedbackContext } from "../../../Components/Context/FeedbackContext";
import { useGetToken } from '../../../Hooks/CustomHooks';
import PermissionsGate from '../../../api/PermissionsGate';
import { SCOPES } from '../../../config/permissions-map';
import SelectPermision from './select_permission';

export default function EditRole({ roleEdit, setRoleEdit, setShowEditRole, showEditRole, setRefreshData }) {
    const { feedbackContext, setFeedbackContext } = useContext(FeedbackContext);
    const [updatedRole, setUpdatedRole] = useState(null);
    const { register, handleSubmit, formState: { errors }, reset, setValue } = useForm();
    const [listPermission, setListPermission] = useState(null);

    const onSubmit = dataUpdatedRole => {
        setUpdatedRole({ ...dataUpdatedRole, listPermissions: listPermission });
        setShowEditRole(false);
    };



    useEffect(() => {
        if (roleEdit) {
            setValue('id', roleEdit.id);
            setValue('name', roleEdit.name);
        }
    }, [roleEdit]);

    useEffect(() => {
        setListPermission(roleEdit.permissionList);
    }, [roleEdit.permissionList]);

    const token = useGetToken();
    //Llamada al servicio de EDITUSER
    let { data, isLoading, isError, error } = useQuery([KeyNames.SessionRespuesta, updatedRole && updatedRole],
        async () => await Api.editRole({ updatedRole: updatedRole, token }),
        {
            enabled: Boolean(updatedRole)
        });

    useEffect(() => {
        if (data) {
            if (data.success) {
                setFeedbackContext({ ...feedbackContext, showMessage: true, idMessage: 101 });
                reset(null);
                setUpdatedRole(null);
                setRefreshData(true);
                setTimeout(window.location.reload(), 2000);
            } else {
                setFeedbackContext({ ...feedbackContext, showError: true, idError: data.errorId });
            }
        }

    }, [data]);

    if (isLoading) return (<Loading />)
    if (isError) return (<ErrorConnection error={error/*.response.status*/} />)

    return (
        <PermissionsGate RenderError={() => <></>} scopes={[SCOPES.GESTION_USUARIOS]} >
            <Modal className='mw-750p' size="lg" show={showEditRole} onHide={() => setShowEditRole(false)} aria-labelledby="contained-modal-title-vcenter" scrollable={true}
                centered>
                <Modal.Header>
                    <Modal.Title>Actualizar rol</Modal.Title>
                </Modal.Header>

                <Modal.Body className=' mx-5 my-7' >
              
                        <form className='' >
                            <div className="fv-row mb-7 ">

                                <label className="required fw-bold fs-6 mb-2">Nombre de rol</label>

                                <input defaultValue={roleEdit.id} type="text" {...register("name", { required: true })} className="form-control form-control-solid mb-3 mb-lg-0" placeholder="Nombre Completo" />
                                <>{errors.id && <span className="text-danger">Ingresar el rol</span>}</>
                            </div>

                        </form>
                        <SelectPermision listPermissionSelectDefault={listPermission} setListPermission={setListPermission}></SelectPermision>
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secundary" onClick={() => setShowEditRole(false)}>Cancelar</Button>
                    <Button variant="primary" onClick={handleSubmit(onSubmit)}>Actualizar</Button>
                </Modal.Footer>
            </Modal>
        </PermissionsGate>
    )
}
